import { useTranslation } from 'react-i18next';
import {
  Headings,
  ModalOverlay,
  SentaraLogo,
  MDLiveLogo,
  VirtualIcon,
  PhoneCallIcon,
  Loader,
} from '@sentara-health/optimahealth_web';
import { VirtualVisitModalBox } from 'templates';
import { SERVICE_PHONE_NUMBER_BEHAVIORAL_HEALTH, SuperScript } from 'common';
import { useVirtualPopUpHooks } from './hooks/VirtualPopUpHooks';
import { GlobalContext } from 'context';
import { useContext } from 'react';

interface BehavioralPopUpProps {
  closeModal: () => void;
  mdliveCopay?: string;
  sentaraCopay?: string;
}
function BehavioralPopUp({
  closeModal,
  mdliveCopay,
  sentaraCopay,
}: Readonly<BehavioralPopUpProps>) {
  // Initialize translation hook
  const { t } = useTranslation();

  const behavioralPopUpHooks = useVirtualPopUpHooks();
  const { ssoEndPoints, getFeature } = useContext(GlobalContext);
  const isMedicaidOrDsnpMember =
    !!getFeature?.HomeAddressMedicaid || !!getFeature?.HomeAddressDSNP;

  const sentaraDisclaimerList = [
    {
      text: t('virtualVisitCare.NurseOnCall.sentaraContent.disclaimerNote2'),
      style: 'mt-3',
    },
  ];

  const mdLiveDisclaimerList = [
    {
      superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_TWO}</sup>,
      text: t('virtualVisitCare.disclaimerNote1Common'),
      style: 'font-size-14 mt-2',
    }!,
    {
      text: t('virtualVisitCare.NurseOnCall.sentaraContent.disclaimerNote2'),
      style: 'mt-3',
    }!,
  ];

  return (
    <>
      <ModalOverlay
        className="virtual-visit-selection"
        data-testid={'BehavioralSelectionId'}
        isOpen
        onClose={closeModal}
        overlayInfo="behavioral selection"
      >
        <div>
          <Headings
            level={2}
            text={t('virtualVisitCare.selectProvider')}
            variant="regular"
          />
          <div className="d-flex flex-column flex-lg-row gap-4 mt-2 justify-content-center">
            <div className="curved-box">
              <VirtualVisitModalBox
                logoImage={<SentaraLogo />}
                title={t('virtualVisitCare.sentaraHealthTitle')}
                subtitle={
                  t('virtualVisitCare.behavioral.sentaraContent.label')!
                }
                badgeImage={<PhoneCallIcon />}
                content={t(
                  'virtualVisitCare.behavioral.sentaraContent.serviceContent'
                )}
                buttonLabel={t(
                  'virtualVisitCare.behavioral.sentaraContent.buttonText'
                )}
                buttonTestId="sentaraCallButton"
                buttonOnClick={() => {
                  behavioralPopUpHooks.PhoneNumberLink({
                    phoneNumber: SERVICE_PHONE_NUMBER_BEHAVIORAL_HEALTH,
                  });
                }}
                displayBlock={true}
                minHeight={'254'}
                disclaimers={sentaraDisclaimerList}
              />
            </div>
            <div className="curved-box">
              <VirtualVisitModalBox
                logoImage={<MDLiveLogo />}
                title={t('virtualVisitCare.mdliveTitle')}
                costInfo={t('virtualVisitCare.costInfo')}
                badgeImage={<VirtualIcon />}
                superTextTwo={SuperScript.VIRTUAL_DISCLAIMER_TWO}
                costValue={mdliveCopay}
                content={t(
                  'virtualVisitCare.behavioral.mdLiveContent.serviceContent'
                )}
                buttonLabel={t('virtualVisitCare.scheduleAppointment')}
                buttonTestId="scheduleMDliveAppointment"
                buttonOnClick={() => {
                  behavioralPopUpHooks.getMDliveSSOUrlFromAPI(
                    ssoEndPoints?.VirtualVisitSSO
                  );
                }}
                minHeight={'180'}
                disclaimers={mdLiveDisclaimerList}
                deductibleBlock={!isMedicaidOrDsnpMember}
                deductibleText={t('virtualVisitCare.deductibleNote')}
              />
            </div>
          </div>
        </div>
      </ModalOverlay>
      {behavioralPopUpHooks?.loading ? <Loader /> : null}
    </>
  );
}

export default BehavioralPopUp;
